export const spanish = !window.location.pathname.includes(
  'en-us' || '&language=en'
);
export const lang = spanish ? '/mex/es-mx' : '/mex/en-us';

export const DEV = {
  api_services: {
    BASE_URL: '/QAapi-foreverliving/Ecomm/1.0/api/',
    client: 'QA_ECOM',
    environment: 'TEST',
    token: 'E233FB7C-CE04-41A5-9B4B-7DA194EF168C',
  },
  cms_services: {
    BASE_URL: '/cms',
  },
  payment_services: {
    BASE_URL: 'https://www.foreverliving.com.mx/EvoPay/api/',
    REF:
      'https://evopaymentsmexico.gateway.mastercard.com/form/version/72/merchant/TESTFORLVING/session.js',
    client: 'QA_ECOM',
    environment: 'TEST',
    token: 'E233FB7C-CE04-41A5-9B4B-7DA194EF168C',
  },
  cdn: {
    cdn_path: 'https://www.shopforeverliving.com.mx:1338',
  },
};

export const QA = {
  api_services: {
    BASE_URL: '/QAapi-foreverliving/Ecomm/1.0/api/',
    client: 'QA_ECOM',
    environment: 'TEST',
    token: 'E233FB7C-CE04-41A5-9B4B-7DA194EF168C',
  },
  cms_services: {
    BASE_URL: '/cms',
  },
  payment_services: {
    BASE_URL: 'https://www.foreverliving.com.mx/EvoPay/api/',
    REF:
      'https://evopaymentsmexico.gateway.mastercard.com/form/version/72/merchant/TESTFORLVING/session.js',
    client: 'QA_ECOM',
    environment: 'TEST',
    token: 'E233FB7C-CE04-41A5-9B4B-7DA194EF168C',
  },
  cdn: {
    cdn_path: 'https://www.shopforeverliving.com.mx:1338',
  },
};

export const PROD = {
  api_services: {
    BASE_URL: '/apiecom/1.0/api/',
    client: 'ECOM-API',
    environment: 'PRD',
    token: '65614E2D-E03A-4BFA-827A-582C9C5DFFA4',
  },
  cms_services: {
    BASE_URL: '/cms',
  },
  payment_services: {
    BASE_URL: 'https://www.foreverliving.com.mx/EvoPayPrd/api/',
    REF:
      'https://evopaymentsmexico.gateway.mastercard.com/form/version/72/merchant/1243349/session.js',
    client: 'ECOM-API',
    environment: 'PRD',
    token: '65614E2D-E03A-4BFA-827A-582C9C5DFFA4',
  },
  cdn: {
    cdn_path: 'https://www.shopforeverliving.com.mx:5000',
  },
};

// eslint-disable-next-line import/no-mutable-exports
let Config = null;
const isDevelop =
  window && window.location && window.location.host.includes('localhost');
const isQA = window && window.location && window.location.port.includes('1339');
const isProd =
  window &&
  window.location &&
  window.location.host.includes('shopforeverliving') &&
  window &&
  window.location &&
  !window.location.port.includes('1339');

if (isDevelop) Config = DEV;
if (isQA) Config = QA;
if (isProd) Config = PROD;

export default Config;
